import { IRigContractAmendment } from '../../interfaces/irig-contract-amendment';
import { RigContract } from '../rig-contract';

export class RigContractAmendmentBase {
  RigContractAmendmentId: number;
  RigContractId: number;
  EffectiveDate: Date;
  RevisedContractEnd: Date;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  RigContract?: RigContract;

  constructor(item?: IRigContractAmendment) {
    if (item) {

      this.RigContractAmendmentId = item.RigContractAmendmentId;
      this.RigContractId = item.RigContractId;
      this.EffectiveDate = item.EffectiveDate ? new Date(item.EffectiveDate) : null;
      this.RevisedContractEnd = item.RevisedContractEnd ? new Date(item.RevisedContractEnd) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.RigContract = new RigContract(item.RigContract);
    }
  }
}